import axios from "axios";
import React, { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import Select from "react-select";
import { JdsButton } from "../../../components/jds/JdsButton";
import { jdsSelectProps } from "../../../components/jds/selectProps";
import { INSTALLLMENTS } from "./constants";
import { PlanFormWarnings } from "./PlanFormWarnings";

// Rótulo acima do campo; obrigatório leva asterisco vermelho depois do texto.
const Label = ({ required, children, ...rest }) => (
  <label {...rest}>
    {children}
    {required && (
      <span className="text-danger" aria-hidden="true">
        {" "}*
      </span>
    )}
  </label>
);

// Erro abaixo do campo.
const FieldError = ({ show, children }) =>
  show ? <div className="invalid-feedback d-block">{children}</div> : null;

export default function Step1(props) {
  const [isLoading,setIsLoading] = useState(true);
  const [featureGroups,setFeatureGroups] = useState({});
  const [displayValue, setDisplayValue] = useState("");

  const loadFeatureGroups = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/feature_groups?page_size=999999`
    );
    let featureGroups = response.data.data.data;
    setFeatureGroups(featureGroups);
    setIsLoading(false);
  };

  useEffect(() => {
    loadFeatureGroups();
  }, []);
  
  const formatToCurrency = (value) => {
    const number = Number.parseFloat(value);
    return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const handleChange = (e) => {
    let { value } = e.target;
    setDisplayValue(value);
  };

  const handleBlur = () => {
    let numericValue = displayValue.replace(/[^\d,]/g, "").replace(",", ".");
    numericValue = parseFloat(numericValue) || 0;
    
    const formattedValue = formatToCurrency(numericValue);
    
    setDisplayValue(formattedValue);
    props.formik.setFieldValue("amount", numericValue);
  };

  useEffect(() => {
    if (!isNaN(props.formik.values.amount)) {
      const formattedValue = formatToCurrency(props.formik.values.amount);
      setDisplayValue(formattedValue);
    }
  }, [props.formik.values.amount]);

  const formik = props.formik;
  const hasError = name => Boolean(formik.errors[name] && formik.touched[name]);
  const inputClass = name =>
    "form-control" + (hasError(name) ? " is-invalid" : "");
  const selectClass = name =>
    "ap-select" + (hasError(name) ? " is-invalid" : "");

  return (
    <BlockUi tag="div" blocking={formik.isSubmitting}>
      <h1 className="jds-title-lg ap-title">
        {props.id ? "Editar plano" : "Cadastrar plano"}
      </h1>
      <div className="jds-card">
        <PlanFormWarnings planId={props.id} formik={formik} />
        <div className="ap-grid">
          <div className="form-group">
            <Label htmlFor="name" required>
              Nome
            </Label>
            <input
              type="text"
              id="name"
              name="name"
              className={inputClass("name")}
              value={formik.values.name}
              onChange={formik.handleChange}
            />
            <FieldError show={hasError("name")}>{formik.errors.name}</FieldError>
          </div>
          <div className="form-group">
            <Label htmlFor="periodicity" required>
              Duração (em dias)
            </Label>
            <input
              type="number"
              id="periodicity"
              name="periodicity"
              className={inputClass("periodicity")}
              value={formik.values.periodicity}
              onChange={formik.handleChange}
            />
            <FieldError show={hasError("periodicity")}>
              {formik.errors.periodicity}
            </FieldError>
          </div>
          <div className="form-group">
            <Label htmlFor="amount" required>
              Valor do plano
            </Label>
            <input
              type="text"
              id="amount"
              name="amount"
              disabled={Boolean(props.id)}
              className={inputClass("amount")}
              value={displayValue}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <FieldError show={hasError("amount")}>{formik.errors.amount}</FieldError>
          </div>
          <div className="form-group">
            <Label htmlFor="installments" required>
              Parcelas
            </Label>
            <Select
              {...jdsSelectProps}
              inputId="installments"
              name="installments"
              isSearchable={true}
              isClearable={true}
              options={INSTALLLMENTS}
              className={selectClass("installments")}
              onChange={option => {
                formik.setFieldValue("installments", option ? option.value : "");
              }}
              value={INSTALLLMENTS.find(option => option.value === formik.values.installments||"")}
              placeholder="Selecione"
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
            />
            <FieldError show={hasError("installments")}>
              {formik.errors.installments}
            </FieldError>
          </div>
          <div className="form-group">
            <Label htmlFor="trial_days" required>
              Dias de trial
            </Label>
            <input
              type="number"
              id="trial_days"
              name="trial_days"
              className={inputClass("trial_days")}
              value={formik.values.trial_days}
              onChange={formik.handleChange}
            />
            <FieldError show={hasError("trial_days")}>
              {formik.errors.trial_days}
            </FieldError>
          </div>
          <div className="form-group">
            <Label htmlFor="feature_group_id" required>
              Grupo de planos
            </Label>
            {!isLoading ? (
              <Select
                {...jdsSelectProps}
                inputId="feature_group_id"
                name="feature_group_id"
                isSearchable={true}
                isClearable={true}
                options={featureGroups}
                className={selectClass("feature_group_id")}
                onChange={option => {
                  formik.setFieldValue("feature_group_id", option.id);
                }}
                value={featureGroups.find(option => option.id === formik.values.feature_group_id)}
                placeholder="Selecione"
                getOptionLabel={option => option.name}
                getOptionValue={option => option.id}
              />
            ) : null}
            <FieldError show={hasError("feature_group_id")}>
              {formik.errors.feature_group_id}
            </FieldError>
          </div>
        </div>
        <div className="ap-actions">
          <JdsButton onClick={formik.handleSubmit}>Salvar plano</JdsButton>
        </div>
      </div>
    </BlockUi>
  );
}
